// API Configuration - shared with other Attraxion apps
const API_CONFIG = {
  stage: process.env.REACT_APP_API_STAGE || 'dev',
  baseUrl: process.env.REACT_APP_MAIN_API_URL || 'https://vc9kugsjnd.execute-api.eu-north-1.amazonaws.com',

  get endpoint() {
    return `${this.baseUrl}/${this.stage}`;
  }
};

export default API_CONFIG;
